import React from "react";

type SectionDescriptionProps = {
  title: string;
  description?: string;
};

export const SectionDescription: React.FC<SectionDescriptionProps> = ({
  title,
  description,
}) => (
  <div className="flex items-stretch gap-4 max-lg:gap-3">
    <div className="w-px shrink-0 rounded-[1px] bg-[#E0E0E0]" />
    <div className="flex max-w-[600px] min-w-0 flex-col gap-1">
      <span className="font-secondary font-medium text-dark">{title}</span>
      {description && (
        <span className="font-secondary text-[13px] text-dark-600">
          {description}
        </span>
      )}
    </div>
  </div>
);
